import { useState } from "react";

import { IgButton, IgLink, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ImageLibraryDialog } from "@src/components/Dialogs/ImageLibraryDialog";
import { URLInputDialog } from "@src/features/experienceBuilder/modifications/basicMods/URLInputDialog";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";
import { useDialog } from "@src/hooks/dialog";

import { InputProps } from "./types";

export const ImageInput = ({ label, value, onChange }: InputProps) => {
  const theme = useTheme();
  const imageLibraryDialog = useDialog("imageLibrary");
  const [urlDialogOpen, setUrlDialogOpen] = useState(false);

  const handleSelectImage = () => {
    imageLibraryDialog.open({
      id: imageLibraryDialog.id,
      onUpdateImage: onChange,
    });
  };

  return (
    <>
      <Stack spacing={1}>
        <Panel.Header>{label}</Panel.Header>
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={3}
          sx={{
            border: `1px solid ${theme.igBorders.core.default}`,
            borderRadius: "8px",
            backgroundColor:
              theme.igBackgroundColors.interactive.neutral.default,
            minHeight: 200,
            padding: 5,
          }}
        >
          {value ? (
            <>
              <img
                src={value}
                alt="Selected"
                style={{
                  maxWidth: "100%",
                  maxHeight: 140,
                  objectFit: "contain",
                  borderRadius: 4,
                }}
              />
              <IgTypography
                variant="subtitle1"
                color="text.secondary"
                noWrap
                sx={{ maxWidth: "100%" }}
              >
                {value.split("/").pop()}
              </IgTypography>
              <IgButton
                variant="outlined"
                color="secondary"
                size="small"
                onClick={handleSelectImage}
              >
                Change image
              </IgButton>
            </>
          ) : (
            <>
              <IgButton
                variant="outlined"
                color="secondary"
                size="small"
                onClick={handleSelectImage}
              >
                Browse library
              </IgButton>
              <IgTypography variant="body1" color="text.secondary">
                or{" "}
                <IgLink
                  component="button"
                  onClick={() => setUrlDialogOpen(true)}
                  sx={{ verticalAlign: "baseline" }}
                >
                  add an image URL
                </IgLink>
              </IgTypography>
            </>
          )}
        </Stack>
      </Stack>
      <ImageLibraryDialog id={imageLibraryDialog.id} />
      <URLInputDialog
        open={urlDialogOpen}
        onClose={() => setUrlDialogOpen(false)}
        onApply={onChange}
      />
    </>
  );
};
